<template>
  <v-container fluid class="container">
    <Breadcrumbs
      :items="breadcrumbs"/>
    <v-toolbar flat>
      <ejs-dropdownlist v-if="!lcyIsEur" id='pleco_currency' :dataSource='currencyDropdownDataSource'
                        :change='onCurrencyDropdownChange' v-model="currencyDropdown"
                        placeholder='Currency' width='130' class="pr-4"></ejs-dropdownlist>
      <ejs-dropdownlist id='pleco_pdf_layout' :dataSource='pdfLayoutDropdownDataSource'
                        :change='onPdfLayoutDropdownChange' v-model="pdfLayoutDropdown"
                        placeholder='Layout' width='150' class="pr-4"></ejs-dropdownlist>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click='excelDownloadClick'>
        Export to Excel
      </v-btn>
    </v-toolbar>
    <v-spacer></v-spacer>
    <ejs-treegrid :dataSource='items' v-if='items' childMapping='sub' :enableCollapseAll='false'
                  :allowResizing='true' :frozenRows='rows' :selectionSettings='selectionOptions'
                  :frozenColumns='columns' :treeColumnIndex='0' :allowFiltering='true' :filterSettings="{type: 'Menu'}"
                  :allowExcelExport='true' :excelHeaderQueryCellInfo='excelHeader'>
      <e-columns>
        <e-column field='summary_pos' :headerText="translate('plannings_plbs_summary_pos')" width='200'></e-column>
        <e-column field='position' headerText='Position' width='230'></e-column>
        <e-column textAlign='center' :columns='valuesColumns'>
        </e-column>
      </e-columns>
    </ejs-treegrid>

    <Snackbar :text="notificationText"
              :type="notificationType" />
    <v-overlay :value="loader"
               :z-index="1000">
      <v-progress-circular indeterminate
                           size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapState } from 'vuex';
  import {
    TreeGridPlugin, ExcelExport, Freeze, Resize, Filter,
  } from '@syncfusion/ej2-vue-treegrid';
  import Breadcrumbs from '@/components/Breadcrumbs';
  import Snackbar from '@/components/Snackbar';
  import api from '../api/lbt-api';

  Vue.use(TreeGridPlugin);

  const {
    getSummaryPLECOForPlanning,
  } = api;

  export default {
    name: 'SummaryPortfolio',
    components: {
      Breadcrumbs,
      Snackbar,
    },
    data() {
      return {
        notificationText: '',
        loader: false,
        notificationType: null,
        headers: [],
        items: [],
        dataLoaded: true,
        expanded: [],
        rows: 0,
        columns: 2,
        selectionOptions: { mode: 'Cell', type: 'Multiple', cellSelectionMode: 'Box' },
        breadcrumbs: [
          {
            translationKey: 'breadcrumbs_plannings',
            route: '/plannings',
            disabled: false,
          },
          {
            translationKey: 'Summary pl eco',
            disabled: true,
          },
        ],
        valuesColumns: [],
        highlightCellAttributes: { class: 'highlight-cell' },
        currencyDropdown: 'LCY',
        currencyDropdownValue: 'LCY',
        currencyDropdownDataSource: ['LCY', 'EUR'],
        pdfLayoutDropdown: 'Regular',
        pdfLayoutDropdownValue: false,
        pdfLayoutDropdownDataSource: ['Regular', 'PDF Layout'],
      };
    },
    computed: {
      ...mapGetters('translations', [
        'translate',
      ]),
      ...mapState('plannings', [
        'activePlanning',
      ]),
      lcyIsEur() {
        const lcy = this.activePlanning && this.activePlanning.lcy_option;
        return lcy && lcy.option === 'EUR';
      },
    },
    async created() {
      await this.fetchData();
    },
    methods: {
      async fetchData() {
        this.loader = true;
        this.valuesColumns = [];
        try {
          const planning = await getSummaryPLECOForPlanning(
            this.$route.params.planningId,
            this.currencyDropdownValue,
            this.pdfLayoutDropdownValue,
          );
          this.headers = planning.periods;
          this.items = planning.rows;
          this.prepareValuesGridHeaders();
        } catch (message) {
          this.notificationText = message;
          this.notificationType = 'error';
          setTimeout(() => { this.notificationText = null; }, 100);
        } finally {
          this.loader = false;
        }
      },
      onCurrencyDropdownChange(selected) {
        this.currencyDropdownValue = selected.value;
        setTimeout(this.fetchData, 100);
      },
      onPdfLayoutDropdownChange(selected) {
        this.pdfLayoutDropdownValue = selected.value === 'PDF Layout';
        setTimeout(this.fetchData, 100);
      },
      prepareValuesGridHeaders() {
        const item = this.items[0];
        for (let i = 0; i < item.values.length; i += 1) {
          this.valuesColumns.push({
            field: `values.${i}`,
            headerText: i,
            headerValueAccessor: this.lookupValuesHeader,
            customAttributes: this.highlightCellAttributes,
            width: 70,
            allowFiltering: false,
            textAlign: 'right',
            format: 'n2',
          });
        }
      },
      lookupValuesHeader(idx) {
        return this.headers[Number(idx)];
      },
      excelDownloadClick() {
        const grid = document.getElementsByClassName('e-grid')[0].ej2_instances[0];
        const excelExportProperties = {
          exportType: 'CurrentPage',
          fileName: `PL eco summary - Planning - ${this.activePlanning.year}-${this.activePlanning.month}.xlsx`,
        };
        grid.excelExport(excelExportProperties);
      },
      excelHeader(args) {
        const { cell } = args;
        if (cell.index > 2) {
          cell.value = this.headers[cell.value];
        }
      },
    },
    provide: {
      treegrid: [ExcelExport, Freeze, Resize, Filter],
    },
  };
</script>

<style>
  @import '../../node_modules/@syncfusion/ej2-vue-treegrid/styles/material.css';
  .e-grid .e-altrow {
    background-color: #fafafa;
  }
  .e-grid .e-headercell.highlight-cell, .highlight-cell {
    background: #eeeeee;
  }
  .e-headercell {
    padding: 15px 0 !important;
  }
  .e-headercell .e-headercelldiv {
    text-align: center;
  }
  .e-treerowcell{
    padding: 0 !important;
  }
  .e-rowcell {
    padding: 3px !important;
  }
</style>
